import { connect } from 'react-redux';
import HeatMap from '../../components/Nuclei/HeatMap';

const mapStateToProps = state => ({
  cellPopulation: state.cellPopulation,
});

export default connect(mapStateToProps)(HeatMap);



// WEBPACK FOOTER //
// ./src/containers/Nuclei/HeatMap.js